import { render, staticRenderFns } from "./OnboardingStep1.vue?vue&type=template&id=63a0c6d1"
import script from "./OnboardingStep1.vue?vue&type=script&lang=js"
export * from "./OnboardingStep1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports